export function polystr(Poly_coords) {
    let _str = Poly_coords.map(position => `${position[0]} ${position[1]}`).join(',') 
    let poly = `POLYGON((${_str}))`
    let bbox = [
               [Math.min(...Poly_coords.map(position => position[0])),
                Math.min(...Poly_coords.map(position => position[1]))],  
              [ Math.max(...Poly_coords.map(position => position[0])),
                Math.max(...Poly_coords.map(position => position[1]))]
                ]
    let bbox_str = bbox.map(position => `${position[0]}%2C${position[1]}`).join('%2C') 
    let bbboxcorner = [
                      [bbox[0][0], bbox[1][1]],
                      [bbox[1][0], bbox[1][1]],
                      [bbox[1][0], bbox[0][1]],
                      [bbox[0][0], bbox[0][1]]
          ]
    return {poly ,bbox_str, bbboxcorner}
      
    }

    export function PolyCord(featurecoords){
        let bbox_str 
        let poly 
        let bbboxcorner 
          
        if (featurecoords !== undefined) {
          bbox_str = polystr(featurecoords[0]).bbox_str
          poly = polystr(featurecoords[0]).poly
          bbboxcorner =  polystr(featurecoords[0]).bbboxcorner
    
        }
        return {bbox_str, poly, bbboxcorner}
      }

